import React from "react";
import { motion } from "framer-motion";
import towel3 from "../assets/towel3.png"

const AboutDraftContent = () => {
  return (
    <div className="w-full overflow-x-hidden text-center my-12 px-4 md:px-10">
      {/* Section 1 */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.3 }} // 👈 re-trigger every time
      >
        <h1 className="text-3xl md:text-6xl font-bold mb-6">
          Our Heritage of Excellence
        </h1>

        <p className="text-base md:text-xl font-sans mx-auto max-w-2xl mb-2">
          Since 1985, Mansafa has been at the forefront of textile innovation,
          creating premium towel collections
        </p>

        <p className="text-base md:text-xl font-sans mx-auto max-w-2xl mb-2">
          that blend traditional craftsmanship with modern luxury.
        </p>

        <p className="text-sm md:text-lg font-sans mx-auto max-w-3xl text-gray-600">
          Carrying forward a legacy of quality, comfort, and trust for
          businesses worldwide.
        </p>
      </motion.div>

      {/* Section 2 */}
      <div className="flex flex-col md:flex-row justify-between items-center mt-14 gap-10">
        {/* Left side (text slides in right → left) */}
        <motion.div
          className="flex-1 text-left"
          initial={{ x: 150, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }} // 👈 repeat on scroll
        >
          <h1 className="text-2xl md:text-4xl font-bold mb-4">
            Where Quality Meets Tradition
          </h1>
          <p className="text-sm md:text-lg font-sans text-gray-700 mt-8">
            We specialize in crafting premium 100% cotton towels, offering a
            wide variety of styles, colors, weights, and quality grades to suit
            every need. Each towel reflects the perfect balance of timeless
            tradition and modern innovation, ensuring durability, comfort, and
            elegance. This dedication has made Mansafa a trusted choice for
            businesses, hotels, and retailers worldwide.
          </p>
          <p className="text-sm md:text-lg font-sans text-gray-700 mt-6">
            We also craft 100% bamboo towels, known for their natural softness,
            absorbency, and eco-friendly qualities. Our range further includes
            premium bedsheets and traditional Ihram garments, designed to
            deliver lasting comfort, reliability, and elegance.
          </p>
        </motion.div>

        {/* Right side (image flips in from right) */}
        <motion.div
          className="flex-1 flex justify-center"
          initial={{ rotateY: 90, opacity: 0 }}
          whileInView={{ rotateY: 0, opacity: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }} // 👈 repeat on scroll
        >
          <img
  src={towel3}
  alt="towel image"
  className="w-full  max-w-lg sm:max-w-xl md:max-w-2xl  h-auto rounded-lg shadow-lg object-cover"
/>

        </motion.div>
      </div>
    </div>
  );
};

export default AboutDraftContent;
